export enum ForegroundItemType {
  Rss = 0,
  ClockTimer = 1
}
